import { CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { THEME_LABELS } from '@/lib/company-qualification';
import type { AnalystScope } from '@shared/types/company-analyst';
import type { QualificationThemeKey } from '@shared/types/company-qualification';

interface Props {
  scope: AnalystScope;
  /** Themes the analyst recommends deepening next, in its order. */
  deepen: QualificationThemeKey[];
  onShowAnalysis: () => void;
  onDeepen: (theme: QualificationThemeKey) => void;
}

/** End of a closed step in the analyst's chat: where to go next, as buttons. */
export const AnalystStepEnd = ({ scope, deepen, onShowAnalysis, onDeepen }: Props) => (
  <div className="space-y-3 rounded-xl border border-domino-cardBorder bg-white/80 px-4 py-3">
    <p className="flex items-center gap-2 text-sm font-semibold text-domino-ink">
      <CheckCircle2 className="h-4 w-4 text-emerald-700" aria-hidden />
      {scope === 'broad' ? 'Qualification terminée' : `Thème « ${THEME_LABELS[scope].label} » approfondi`}
    </p>
    <div className="flex flex-wrap gap-2">
      <Button size="sm" onClick={onShowAnalysis}>Voir la restitution</Button>
      {deepen.map((theme) => (
        <Button key={theme} size="sm" variant="secondary" onClick={() => onDeepen(theme)}>
          Approfondir « {THEME_LABELS[theme].label} »
        </Button>
      ))}
    </div>
  </div>
);
